import React from 'react';
import { Button, Form, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class CourseEnrollment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            semesterOptions: [{ id: 1 }]
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.enrollStudent = this.enrollStudent.bind(this);
    }

    componentDidMount() {

    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.semester !== prevProps.semester) {
            this.resetForm();
        }
    }

    resetForm() {
        this.setState({

            semesterNum: null,
            course: null,
            academicYear: null,
            semester: null,
            courseImplementation: null
        });
    }

    enrollStudent() {
        const student = JSON.parse(localStorage.getItem('student'));
        if (!this.state.semesterNum || !this.state.courseImplementation || !this.state.course) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!this.state.semesterNum) { this.setState({ semesterNumErr: true }); } else { this.setState({ semesterNumErr: false }); }
            if (!this.state.course) { this.setState({ courseErr: true }); } else { this.setState({ courseErr: false }); }
            if (!this.state.courseImplementation) { this.setState({ courseImplementationErr: true }); } else { this.setState({ courseImplementationErr: false }); }
        } else {
            this.setState({ loader: true });
            let obj = {
                studentStudyProgram: {
                    id: localStorage.getItem('currentEducation') ? student.id : student.studentStudyProgramId
                },
                courseImplementation: {
                    id: this.state.courseImplementation
                }
            };

            axios.post(`/course/implementation-enrollment/${this.props.semester}/${this.state.semesterNum}/false/`, { ...obj })
                .then(res => {
                    this.setState({ loader: false });

                    this.resetForm();
                    toast('Uspješno ste upisali studenta na predmet!');
                })
                .catch(err => {
                    this.setState({ loader: false });
                    if (err.response.data === 'Student is already enrolled in this course implementation!') { toast('Student je već upisan na ovu implementaciju!'); } else
                    if (err.response.data === 'Student is enrolled in this semester more than once!') { toast('Student je više puta upisan u semestar!'); } else
                    if (err.response.data === 'Student is not enrolled in this semester!') { toast('Student nije upisan u semestar!'); } else { toast('Došlo je do greške. Student nije upisan na predmet!'); }
                });
        }
    }

    handleInputChange(event, { name, value }) {
        if (name === 'course') { this.props.fetchSemesterNumOptions(value.id); if (this.props.semester) this.props.fetchCourseImplementationOptions(value.courseBasicId, this.props.semester); }

        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>

                <Loader active={this.state.loader} />

                <Form>
                    <Form.Group widths="equal">
                        <Form.Field required error={this.state.courseErr}>
                            <label>Predmet </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir predmeta"
                                value={this.state.course}
                                onChange={this.handleInputChange}
                                name="course"
                                options={this.props.courseOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.semesterNumErr}>
                            <label>Semestar (u kojem je prvi put slušan predmet)</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir semestra"
                                value={this.state.semesterNum}
                                onChange={this.handleInputChange}
                                name="semesterNum"
                                options={this.props.semesterNumOptions}
                                search
                                disabled={!this.state.course}
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.courseImplementationErr}>
                            <label>Implementacija predmeta </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir implementacije"
                                value={this.state.courseImplementation}
                                onChange={this.handleInputChange}
                                name="courseImplementation"
                                disabled={!this.state.course || !this.props.semester}
                                options={this.props.courseImplementationOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                    </Form.Group>
                    <Button
                        floated="right"
                        color="blue"
                        onClick={() => {
                            this.enrollStudent();
                        }}
                    >Upiši studenta </Button>
                    <br />
                    <br />
                </Form>

                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Students/CourseEnrollment/CourseEnrollment.js